//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminPayslipDocumentController_findOneById,
  Response$AdminPayslipDocumentController_findOneById$Status$200,
  ResponseContentType$AdminPayslipDocumentController_findOneById,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminPayslipDocumentController_findOneById = (options: {
  params: Params$AdminPayslipDocumentController_findOneById['parameter'];
  config?: QueryOptions<
    Response$AdminPayslipDocumentController_findOneById$Status$200[ResponseContentType$AdminPayslipDocumentController_findOneById]
  >;
}) =>
  useApiClient<
    Params$AdminPayslipDocumentController_findOneById,
    Response$AdminPayslipDocumentController_findOneById$Status$200[ResponseContentType$AdminPayslipDocumentController_findOneById]
  >({
    method: 'AdminPayslipDocumentController_findOneById',
    params: { parameter: options.params },
    config: options.config,
  });
